import React, { useState, useEffect } from 'react'
import Explore from '../DiscoverMutualFunds'
import api from '../../../api/axios';
import './result.css';
import GaugeChart from 'react-gauge-chart'
import up from '../../images/trending-up.png'
const res = "/images/misc/risk-factor.png";
// const up = '../../images/trending-up.png'
import DiscoverMutualFunds from "./../DiscoverMutualFunds";



function RiskFactorResult({ handleRetry }) {
  const [score, setScore] = useState(0);
  const [suggestion, setSuggestion] = useState(0);
  const [pdf_url, setURL] = useState("")
  useEffect(() => {
    const fetchRiskFactorData = async () => {
      try {
        const resultRes = await api.get(`/riskfactor/result/`);
        setScore(resultRes.data['total score']);
        setSuggestion(resultRes.data.range[0].description);
        
        // Try to fetch PDF, but handle gracefully if endpoint doesn't exist
        try {
          const pdfRes = await api.get(`/riskfactor/pdf/`);
          console.log("this is the pdf ", pdfRes);
          setURL(pdfRes.data.url);
        } catch (pdfError) {
          console.log("PDF generation not available:", pdfError.response?.status);
          // PDF endpoint might not be available, but don't show error to user
          // User can still see their risk factor results
        }
      } catch (error) {
        console.error("Error fetching risk factor data:", error);
        if (error.response?.status !== 404) {
          alert("Something went wrong while fetching your risk factor results, please try again");
        }
      }
    };

    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      fetchRiskFactorData();
    }
  }, [])

  return (
    <div className='riskfactor-container-result'>
      <div className="profile-form-head">Based on your answers, Here is your Report</div>
      <GaugeChart id="gauge-chart1"
        nrOfLevels={6}
        colors={["#FF5F6D", "#FFC371", "#39B54A"]}
        arcWidth={0.6}
        percent={score / 100}
        textColor="#000000"
        needleColor='#434343'
        hideText={true}
        needleBaseColor="#616262"
        className='hgj'
        formatTextValue={(value) => 'Your performance rating is ' + value + '%'}
      />
      {score >= 90 ? <div className='perform-report best'>Performance Report : {score}%</div> : score >= 80 ? <div className='perform-report avg'>Performance Report : {score}%</div> : score >= 60 ? <div className='perform-report mid'>Performance Report : {score}% </div> : score >= 40 ? <div className='perform-report bad'>Performance Report : {score}% </div> : score >= 20 ? <div className='perform-report worst'>Performance Report : {score}% </div> : score >= 0 ? <div className='perform-report mostworst'>Performance Report : {score}% </div> : ""}
      <p className='riskfactor-suggestion'>Your ability to take risks is evaluated by reviewing your assets and liabilities. An individual with many assets and few liabilities has a high ability to take on risk. Conversely, an individual with few assets and high liabilities has a low ability to take on risk. Also different phases of life affect the capacity to take risk </p>
      <div className='riskfactor-score-board'>
        <div className='riskfactor-score'>You have scored <strong>{score} out of 100</strong></div>
        <div className='riskfactor-score-comment'>Based on your score, we have investment opportunities that suit your profile perfectly to provide peace of mind to attain your financial freedom journey. Get personalised advice to improve your profile and make it healthy today!
        </div>
      </div>
      <p className='riskfactor-suggestion'>{suggestion}</p>
      <button className='riskfactor-retry' onClick={(e) => handleRetry(e)}>Retry</button>
      <div className='riskfactor-btn-row'>
        <button>Share</button>
        {pdf_url && <button><a href={pdf_url} target="_blank" rel="noopener noreferrer">Download</a></button>}
        <button><a href="https://calendly.com/vijaymaheshwari/financialfreedom" target="_blank" rel="noopener noreferrer">Book A Free Call</a></button>

      </div>
      <div className='riskfactor-discover'>
        {/* <div className='riskfactor-discover-head'>Discover Mutual Funds</div> */}
        <DiscoverMutualFunds />
      </div>
      {/* <Explore handleClick={() => {console.log("polre")}}/> */}
    </div>
  )
}

export default RiskFactorResult